/**
 * /wiki — Wiki / Documentation feature layout route.
 *
 * Mirrors `routes/messages/route.tsx`: auth-gate the entry, then mount a
 * two-column layout — secondary rail on the start side + the route
 * Outlet on the end side. Wave 2B replaces the Wave 1C placeholder rail
 * with the real `<WikiSecondaryRail>` that lists docs, filters, opens
 * the new-doc modal, and surfaces a per-row overflow menu.
 *
 * The rail width (280px) and structural shape match `MessagesLayout`
 * exactly so the chrome reads as one product — Wiki, Messages,
 * Settings all share a single secondary-rail visual language.
 */

import { Outlet, createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import { getAccessToken } from '@/auth/cookie-helpers'
import { WikiSecondaryRail } from '@/features/wiki/components/WikiSecondaryRail'

export const Route = createFileRoute('/wiki')({
  component: DocsRouteComponent,
})

function DocsRouteComponent() {
  const navigate = useNavigate()

  useEffect(() => {
    if (!getAccessToken()) {
      navigate({ to: '/login' })
    }
  }, [navigate])

  if (!getAccessToken()) return null

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col">
      <div className="flex h-full min-h-0 flex-1">
        <WikiSecondaryRail />
        <section className="flex min-w-0 flex-1 flex-col">
          <Outlet />
        </section>
      </div>
    </div>
  )
}
